var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticClass: "delete--dialog",
      attrs: { persistent: "", width: "400" },
      model: {
        value: _vm.dtIsOpen,
        callback: function($$v) {
          _vm.dtIsOpen = $$v
        },
        expression: "dtIsOpen"
      }
    },
    [
      _c(
        "v-card",
        { attrs: { color: "primary", dark: "" } },
        [
          _c(
            "v-card-text",
            { attrs: { "text-xs-left": "" } },
            [
              _c(
                "v-layout",
                { staticClass: "mb-1", attrs: { row: "", "align-center": "" } },
                [
                  _c("v-icon", { attrs: { "x-large": "", color: "red" } }, [
                    _vm._v("warning")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ml-4 mt-3 delete--dialog__text" }, [
                    _vm._v(_vm._s(_vm.message))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "text-xs-center" }, [
                _c("b", [_vm._v("ATTENTION")]),
                _vm._v(", cette action est irréversible !")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", { attrs: { color: "white" } }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "pa-0 delete--dialog__actions" },
            [
              _c(
                "v-btn",
                {
                  attrs: { flat: "", color: "white" },
                  on: { click: _vm.handleCancel }
                },
                [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.btnCancel)))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { loading: _vm.isLoading, flat: "", color: "white" },
                  on: { click: _vm.handleDelete }
                },
                [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.btnDeleteConfirm)))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15eb5e84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15eb5e84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/delete-dialog/template.html
// module id = null
// module chunks = 